import React from 'react'

function WD_program_details() {
  return (
    <div>
      {/* ----------------------Mobile view-------------------- */}
      <div className="d-sm-block d-md-none">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-6">Mastering Web Wizardry!</h1>
                <p className="py-2">
                  Dive into the world of web development! Unleash your
                  potential, enrol now, and sculpt a bright future crafting
                  digital landscapes with our cutting-edge courses. Your coding
                  journey begins here!
                </p>
              </div>
              <div className="mt-4 text-center Program_details_1stcomp_text_mobile">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM
                  manipulation, jQuery, Node.js, and database principles, you
                  can start a whole web development journey. Explore complex
                  ideas like React.js, Angular, Spring Boot, MongoDB, and
                  Node.js, leading to practical small to large projects. Develop
                  your abilities to the next level by constructing reliable APIs
                  and dynamic webpages. Come learn the nuances of contemporary
                  web programming with us, and fulfill your dream of being a
                  coder.
                </p>
              </div>
            </div>
            <div className="col-md-12">
              <div>
                <div className=" Details_container shadow-lg px-1 py-4">
                  <h1 className="Details_text text-center  pb-2 border-bottom">
                    Web Development
                  </h1>
                  <div className="view_Details_text">
                    <ul className="pt-2">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -----------------------Desktop View----------------------- */}
      <div className="d-none d-md-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 detail_1stcomp_img">
              <div className="pt-3 Program_details_1stcomp_text">
                <h1 className="fs-2">Mastering Web Wizardry!</h1>
                <p className="py-2">
                  Dive into the world of web development! Unleash your
                  potential, enrol now, and sculpt a bright future crafting
                  digital landscapes with our cutting-edge courses. Your coding
                  journey begins here!
                </p>
              </div>
              <div className="mt-3 Program_details_1stcomp_text">
                <h1 className="display-4">Overview</h1>
                <p className="py-2">
                  With our course on HTML, CSS, Bootstrap, JavaScript, OOP, DOM
                  manipulation, jQuery, Node.js, and database principles, you
                  can start a whole web development journey. Explore complex
                  ideas like React.js, Angular, Spring Boot, MongoDB, and
                  Node.js, leading to practical small to large projects. Develop
                  your abilities to the next level by constructing reliable APIs
                  and dynamic webpages. Come learn the nuances of contemporary
                  web programming with us, and fulfill your dream of being a
                  coder.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div>
                <div className=" Details_container shadow-lg px-3 py-4">
                  <h1 className="Details_text text-center  pb-4 pt-3 border-bottom">
                    Web Development
                  </h1>
                  <div className="Details_text ">
                    <ul className="pt-3">
                      <li>Live conversations with industry professionals</li>
                      <li className="py-3">Project support and Guidance</li>
                      <li>Access to Specialized Course Materials</li>
                      <li className="py-3">25+ Hours of Learning</li>
                      <li>
                        Certificates from reputable MNC's around the world
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default WD_program_details
